<template>
  <div>
    <Navbar />
    <Breadcrumb />
    <b-card class="border-0 mx-auto col-md-8 col-lg-8 col-sm-12">
      <b-card-title>
        <b-row>
          <div class="col-1">
          <div class="survey-type-badge bg-default"><fa-icon name="user" /></div>
          </div>
          <div class="col-8 align-self-center">Profile<br><span class="small muted">{{user.first_name}} {{user.family_name}}</span></div>
          <div class="col-2 align-self-center">
             <!--img src="Bjorn.jpg" style="height:64px;border-radius: 50%;"></img -->
          </div>
          <div class="col-1">
          </div>
        </b-row>
      </b-card-title>
      <b-form @submit.prevent="profile_save">
      <b-row>
      <b-tabs class="col-12">
        <b-tab title="Contact Information">
          <div class="col-10 align-self-center" style="padding-top: 40px;">
            <b-form-group label="First name">
               <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="user.first_name"></b-form-input>
            </b-form-group>
            <b-form-group label="Family name">
               <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="user.family_name"></b-form-input>
            </b-form-group>
            <b-form-group label="E-mail">
               <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="user.email"></b-form-input>
            </b-form-group>
            <b-form-group label="Company Name">
               <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="profile.company_name"></b-form-input>
            </b-form-group>
            <b-form-group label="Address">
               <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="profile.address_1"></b-form-input>
               <br>
               <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="profile.address_2"></b-form-input>
            </b-form-group>
            <b-form-group label="Zip Code">
               <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="profile.zip_code"></b-form-input>
            </b-form-group>
            <b-form-group label="City">
               <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="profile.city"></b-form-input>
            </b-form-group>
          </div>
        </b-tab>
        <b-tab title="E-mail addresses">
          <div class="col-10 align-self-center" style="padding-top: 40px;">
          </div>
        </b-tab>
      </b-tabs>
      </b-row>
      <b-row>
        <div class="col-12 text-right">
           <b-button @click.prevent="profile_save()" type="submit" variant="primary">Save</b-button>
        </div>
      </b-row>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import Navbar from './Navbar.vue';  
import Breadcrumb from './Breadcrumb.vue';  

export default {
  name: 'Profile',
  components: {
    Navbar,
    Breadcrumb
  },
  created() {
    this.profile_get()
    this.user_get()
    this.countries_get();
  },
  data: function () {
    return {
      countries_options: [],
      profile: null,
      user: null,
    }
  },
  computed: {
    anon: function() {
      return this.$store.state.anon;
    },

    user: {
      set() {
        return true;
      },
      get() {
        //return this.$store.state.user;
        return {
          id: this.$store.state.user.id,
          i_name: this.$store.state.user.i_name,
          i_group: this.$store.state.user.i_group,
          i_email: this.$store.state.user.i_email,
          i_lang: this.$store.state.user.i_lang,
          family_name: this.$store.state.user.family_name,
          first_name: this.$store.state.user.first_name,
          email: this.$store.state.user.email,
        }
      }
    }
  },
  methods: {
    user_get: function() {
      this.$store.dispatch('user_fetch', { id: this.$store.state.user_id }).then((res) => {
        this.user = res.data;
      });
    },
    profile_get: function() {
      this.$store.dispatch('profile_fetch', { id: this.$store.state.user_id }).then((res) => {
        this.profile = res.data;
      });
    },
    profile_save: function() {
      this.$store.dispatch('profile_save',{
        "user": this.user,
        "profile": this.profile
      })
    },
    countries_get () {
      this.countries_options = []
      for (var i = 0; i < this.$store.state.countries.length; i++) {
        var country = {
          value: this.$store.state.countries[i].id,
          text: this.$store.state.countries[i].country_name
        }
        this.countries_options.push(country)
      }
    },
  },
}
</script>

